module.exports = __webpack_public_path__ + "img/jiaoyu3.1a008887.png";